var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { EditCustomFieldService } from '@/domains/custom-fields/services/edit-custom-field-service.interface';
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from 'inversify';
let EditCustomFieldCommandContribution = class EditCustomFieldCommandContribution {
    constructor(_i18nService, _editCustomFieldService) {
        this._i18nService = _i18nService;
        this._editCustomFieldService = _editCustomFieldService;
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'custom-field.edit',
            icon: 'SolidEdit',
            label: this._i18nService.t('global.btn.edit'),
        }, {
            execute: (context) => {
                return this._editCustomFieldService.edit(context);
            },
        });
    }
};
EditCustomFieldCommandContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(EditCustomFieldService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof EditCustomFieldService !== "undefined" && EditCustomFieldService) === "function" ? _b : Object])
], EditCustomFieldCommandContribution);
export { EditCustomFieldCommandContribution };
